// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.phoneverification.LandlordPhoneVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  IsPhoneVerifiedRequestDto,
  IsPhoneVerifiedResponseDto,
  SendVerificationCodeRequestDto,
  ValidateVerificationCodeRequestDto,
} from '../..';

export const LandlordPhoneVerificationWebApiHandler_isVerified_Path =
  '/api/web/v1/landlord/phoneVerification/isVerified';

/**
 * Check if a rent payment phone number is verified
 */
export const LandlordPhoneVerificationWebApiHandler_isVerified = (
  postData: IsPhoneVerifiedRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, IsPhoneVerifiedRequestDto, IsPhoneVerifiedResponseDto>(
    {
      endpoint: LandlordPhoneVerificationWebApiHandler_isVerified_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};

export const LandlordPhoneVerificationWebApiHandler_sendVerificationCode_Path =
  '/api/web/v1/landlord/phoneVerification/sendVerificationCode';

/**
 * Send rent payment phone verification code
 */
export const LandlordPhoneVerificationWebApiHandler_sendVerificationCode = (
  postData: SendVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SendVerificationCodeRequestDto, void>(
    {
      endpoint: LandlordPhoneVerificationWebApiHandler_sendVerificationCode_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};

export const LandlordPhoneVerificationWebApiHandler_validateVerificationCode_Path =
  '/api/web/v1/landlord/phoneVerification/validateVerificationCode';

/**
 * Validate rent payment phone verification code
 */
export const LandlordPhoneVerificationWebApiHandler_validateVerificationCode = (
  postData: ValidateVerificationCodeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ValidateVerificationCodeRequestDto, void>(
    {
      endpoint: LandlordPhoneVerificationWebApiHandler_validateVerificationCode_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
